export default function Marquee({ text }) {
  return (
    <div className="marquee">
      <span className="marquee-track">{text}</span>
    </div>
  )
}
